const sidebar = $('.sidebar-backdrop > .sidebar');
const sidebarTiggerMobile = $('.sidebar-trigger-mobile');

/**
 * Adiciona um novo cookie com o valor cookie
 */
const setCookieWithSharedDomain = (cookie, value, days) => {
  const host = window.location.host;

  // remove o app. do início do domínio
  const parts = host.split('.').slice(1);

  // junta o domínio novamente com o ponto inicial
  const domain = '.' + parts.join('.');

  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toGMTString();
  }
  document.cookie = cookie + '=' + value + expires + '; domain=' + domain + '; path=/';
}

/**
 * Da toggle na sidebar, abrindo e fechando dependendo do estado
 */
function toggleSidebarMobile(e) {
  e.stopPropagation();

  if ($(window).width() > 1280) {
    if (sidebar.hasClass('open')) {
      sidebar.removeClass('open');
      sidebar.parent().removeClass('active');
    }
    return;
  }

  if (this !== e.target && $(e.target).parent()[0] !== this) {
    return;
  }

  sidebar.removeClass('collapsed');
  if (!sidebar.hasClass('open')) {
    sidebar.show().addClass('open');
    sidebar.parent().addClass('active');
  } else {
    sidebar.removeClass('open');
    sidebar.parent().removeClass('active');
  }
}

/**
 * Collapsa  a sidebar e adiciona margem aos elementos
 */
function toggleSidebar(e) {
  e.stopPropagation();

  if ($(window).width() > 1280 && sidebar.hasClass('open')) {
    sidebar.removeClass('open');
    sidebar.parent().removeClass('active');
  }

  if (!sidebar.hasClass('collapsed')) {
    closeSidebar();
  } else {
    openSidebar();
  }
}

/**
 * Fecha a sidebar
 */
function closeSidebar() {
  setCookieWithSharedDomain('sidebar', 'collapsed', 2);
  sidebar.addClass('collapsed');
  $('.content-container').addClass('collapsed');
  $('.main-top-navigation').addClass('collapsed');
}

/**
 * Abre a sidebar
 */
function openSidebar() {
  setCookieWithSharedDomain('sidebar', '', 2);
  sidebar.removeClass('collapsed');
  $('.content-container').removeClass('collapsed');
  $('.main-top-navigation').removeClass('collapsed');
}

function closeSidebarManagementSettings() {
  const currentUrl = window.location.href;

  if (currentUrl.includes('/admin') || currentUrl.includes('settings')) {
    closeSidebar();
  }
}

/**
 * Adiciona os listeners da sidebar
 */
function appllyListenerSidebarTrigger() {
  if (sidebarTiggerMobile) {
    sidebarTiggerMobile.on('click', toggleSidebarMobile);
    $('.sidebar-backdrop').on('click', toggleSidebarMobile);
    $('#collapse-button:not(.mobile)').on('click', toggleSidebar);
    $('#collapse-button.mobile').on('click', toggleSidebarMobile);
  }
  $(document).ready(closeSidebarManagementSettings);
}

exports.init = appllyListenerSidebarTrigger;

